import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { getURLParams } from '../../utils';
import { AUTH_PATH, GUEST_PATH } from '../../constants';

import GuestHeader from './TheHeader';
import GuestContent from './TheContent';
import GuestFooter from './TheFooter';
import Licensees from '../../components/CMS/Subscriber/Licensees';
import { fetchGuestContentManagements } from './action';

import GuestPusher from './ThePusher';

const Guest = (props) => {
     const dispatch = useDispatch();
     const navigate = useNavigate();
     const location = useLocation();

     const contentManagements = useSelector((state) => state.subscriber.contentManagements);

     const fetchData = () => {
          if (!contentManagements.length) {
               dispatch(fetchGuestContentManagements());
          }
     };

     useEffect(fetchData, []); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          const params = getURLParams();

          if (params.fromEmail === 'inviteManager') {
               navigate(AUTH_PATH.LOGIN);
          }
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <div className="body-wrapper">
               <GuestPusher />
               <GuestHeader {...props} />
               {location.pathname !== GUEST_PATH.SELLING_GROUPS && <Licensees />}
               <GuestContent />
               <GuestFooter />
          </div>
     );
};

export default Guest;
